export default "/images/air-filtration-units.jpg";